
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1 1)","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#FFF","d":"M13.794 12.457l4.179 4.18-1.356 1.355-4.18-4.179L8.253 18l-1.41-1.41 4.186-4.185-4.159-4.159 1.356-1.356 4.159 4.159 4.205-4.206L18 8.252z"}}),_c('circle',{attrs:{"stroke":"#FFF","stroke-width":"2","cx":"12","cy":"12","r":"12"}})])])
          )
        }
      }
    